module.exports = __webpack_public_path__ + "static/media/login.661b8097.png";